import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CONTACT, WA_LINKS } from "../lib/utils";
import { Mail, Phone, MessageCircle } from "lucide-react";

export function Footer() {
  return (
    <footer className="relative mt-24 bg-navy-800 text-white noise-overlay">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-gold-400/60 to-transparent" />
      <div className="container-luxury py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo variant="light" />
            <p className="mt-8 max-w-md text-balance text-white/70 leading-relaxed">
              Premium property management for NRIs across India.
              <span className="block mt-2 font-display italic text-gold-300">Your properties. Our responsibility.</span>
            </p>
            <div className="mt-10 flex flex-col gap-3 text-sm text-white/80">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-emerald-300 transition-colors">
                <Mail size={16} className="text-gold-400" />{CONTACT.email}
              </a>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 hover:text-emerald-300 transition-colors">
                <Phone size={16} className="text-gold-400" />{CONTACT.phone}
              </a>
              <a href={WA_LINKS.general} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-emerald-300 transition-colors">
                <MessageCircle size={16} className="text-gold-400" />WhatsApp us directly
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 lg:col-span-7 lg:grid-cols-3">
            <div>
              <h4 className="eyebrow text-gold-400">Explore</h4>
              <ul className="mt-5 space-y-3 text-sm text-white/80">
                <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
                <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="eyebrow text-gold-400">Services</h4>
              <ul className="mt-5 space-y-3 text-sm text-white/80">
                <li><Link to="/services#management" className="hover:text-white transition-colors">Property Management</Link></li>
                <li><Link to="/services#acquisition" className="hover:text-white transition-colors">Asset Acquisition</Link></li>
                <li><Link to="/services#disposition" className="hover:text-white transition-colors">Asset Disposition</Link></li>
                <li><Link to="/services#pricing" className="hover:text-white transition-colors">Transparent Pricing</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="eyebrow text-gold-400">Cities</h4>
              <ul className="mt-5 space-y-3 text-sm text-white/80">
                <li>New Delhi NCR</li><li>Mumbai</li><li>Bengaluru</li>
                <li>Kolkata</li><li>Hyderabad</li><li>Ahmedabad · Goa</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="hairline mt-16 opacity-20" />
        <div className="mt-8 flex flex-col items-start justify-between gap-4 text-xs text-white/50 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} AssetCare365. All rights reserved.</p>
          <p className="font-display italic text-white/60">Quiet luxury for homes that deserve attention.</p>
        </div>
      </div>
    </footer>
  );
}
